import SignupForm from '../components/SignupForm';
import React from 'react';

const Signup = () => {
    return (
        <div className='container'>
           <SignupForm className="signup_form"/>
        </div>
    );
}

export default Signup;
